module.exports = __webpack_public_path__ + "fonts/iconfont.eb38359b.woff";